import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';
import {
  SbeSmsApiService,
  type CreateTemplateBodyDto,
  type ListTemplatesResponseDto,
  type TemplateDto,
  type UpdateTemplateBodyDto,
} from '@sbe-spinoff-client/sbe-sms-api';

/**
 * /templates facade. orgId 를 넘기면 단체 컨텍스트 라우트(orgs/:orgId/templates,
 * orval의 orgTemplatesController*)로, 생략하면 개인 컨텍스트 라우트로 위임한다
 * (originators-api.service.ts 와 동일 패턴).
 */
@Injectable({ providedIn: 'root' })
export class TemplatesApiService {
  private readonly api = inject(SbeSmsApiService);

  list(orgId?: string): Observable<ListTemplatesResponseDto> {
    return orgId
      ? this.api.orgTemplatesControllerList<ListTemplatesResponseDto>(orgId)
      : this.api.templatesControllerList<ListTemplatesResponseDto>();
  }

  create(body: CreateTemplateBodyDto, orgId?: string): Observable<TemplateDto> {
    return orgId
      ? this.api.orgTemplatesControllerCreate<TemplateDto>(orgId, body)
      : this.api.templatesControllerCreate<TemplateDto>(body);
  }

  update(id: string, body: UpdateTemplateBodyDto, orgId?: string): Observable<TemplateDto> {
    return orgId
      ? this.api.orgTemplatesControllerUpdate<TemplateDto>(orgId, id, body)
      : this.api.templatesControllerUpdate<TemplateDto>(id, body);
  }

  remove(id: string, orgId?: string): Observable<void> {
    return orgId
      ? this.api.orgTemplatesControllerRemove<void>(orgId, id)
      : this.api.templatesControllerRemove<void>(id);
  }

  copy(id: string, orgId?: string): Observable<TemplateDto> {
    return orgId
      ? this.api.orgTemplatesControllerCopy<TemplateDto>(orgId, id)
      : this.api.templatesControllerCopy<TemplateDto>(id);
  }
}
